import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';

import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';

import { UtilitiesService } from '../../services/utilities.service';


@Component({
  selector: 'app-consorcio-detail',
  templateUrl: './consorcio-detail.component.html',
  styleUrls: ['./consorcio-detail.component.css']
})
export class ConsorcioDetailComponent implements OnInit {

  public consorcioSeleccionado: Consorcio;

  public modoEdicion: boolean = false;
  public consorcios: Consorcio[];
  public query: any;
  public filtro:string;
  constructor(
    private consorcioService: ConsorciosService,
    private _utilities: UtilitiesService,
    private localStorageService: LocalStorageService

  ) {

  }

  ngOnInit() {
    this.filtro = "";
    this.consorcios = [];
    if(sessionStorage.getItem("login") === null){
        window.location.href = "/";
    }
    this.refrescarConsorcios();
  }

  refrescarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this.consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err._body);
      });
  }

  editarRegistro(_consorcio: Consorcio) {
    //_consorcio.vigenciaContrato = new Date(_consorcio.vigenciaContrato.getFullYear(), _consorcio.vigenciaContrato.getMonth() + 1, _consorcio.vigenciaContrato.getDate());
    this.consorcioSeleccionado = _consorcio;
    this.modoEdicion = true;
  }


  agregarRegistro() {
    this.consorcioSeleccionado = null;
    this.modoEdicion = true;
  }


  regresar() {
    this.refrescarConsorcios();
    this.modoEdicion = false;
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/consorcio-detail/consorcio-detail.component.ts